import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import SettingsSwitch from "./SettingsSwitch";
import SettingInput from "./SettingInput";
import Dropdown from "@client.components/Dropdown";

const InsightSettingItem = ({
  notificationType,
  titleKey,
  descriptionElements,
  onSave,
  isNotificationDisabled,
  specialConfig = null,
  icon = null,
}) => {
  const { t } = useTranslation();

  return (
    <div className="setting">
      <div className="switch">
        <SettingsSwitch
          notificationType={notificationType}
          onSave={onSave}
        />
        <div className="setting-title">
          {icon && <img src={icon} alt={t(titleKey)} width={20} height={20} />}
          {t(titleKey)}
        </div>
      </div>
      <div
        className={classNames("value", {
          disabled: isNotificationDisabled(notificationType),
        })}
      >
        {descriptionElements.map((element, index) => {
          if (element.type === "text") {
            return <span key={index}>{t(element.key)}</span>;
          }
          
          if (element.type === "input") {
            return (
              <SettingInput
                key={index}
                notificationType={notificationType}
                onSave={onSave}
                isInput={element.isInput}
                suffix={element.suffix}
                inputClassName={element.inputClassName}
              />
            );
          }

          if (element.type === "dropdown" && specialConfig) {
            return (
              <Dropdown
                key={index}
                items={element.items || []}
                valueKey="value"
                labelKey="label"
                defaultValue={specialConfig.settingsJson[element.fieldKey]}
                onPrepareValue={(val) => parseInt(val)}
                disabled={isNotificationDisabled(notificationType)}
                onSelect={(v) => {
                  onSave({
                    ...specialConfig,
                    settingsJson: {
                      ...specialConfig.settingsJson,
                      [element.fieldKey]: v,
                    },
                  });
                }}
              />
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

InsightSettingItem.propTypes = {
  notificationType: PropTypes.number.isRequired,
  titleKey: PropTypes.string.isRequired,
  descriptionElements: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["text", "input", "dropdown"]).isRequired,
      key: PropTypes.string,
      isInput: PropTypes.bool,
      suffix: PropTypes.string,
      inputClassName: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
        })
      ),
      fieldKey: PropTypes.string,
    })
  ).isRequired,
  onSave: PropTypes.func.isRequired,
  isNotificationDisabled: PropTypes.func.isRequired,
  specialConfig: PropTypes.object,
  icon: PropTypes.string,
};

export default InsightSettingItem;
